module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/remove-43ff891edfd84f65109961b4e99910a1.svg";